/*
  Auto-generated by Spline
*/

import { useThree } from "@react-three/fiber";
import useSpline from "@splinetool/r3f-spline";
import { PerspectiveCamera } from "@react-three/drei";
import {useState} from 'react'

export default function Scene({ ...props }) {
  const { nodes, materials } = useSpline(
    "https://prod.spline.design/kOg1I8r23bnFnDbb/scene.splinecode"
  );
  const state = useThree();
  
  // const {display} =useState(document.getElementById("display"));
  const display = document.getElementById("display")
  // console.log(display); 
  const blue = {
    inside: 4,
    outside: 0,
    finished: 0,
    // 1,2,3,4
    position: [0, 0, 0, 0],
    name: "b",
    show:"blue"

  };
  const red = {
    inside: 4,
    outside: 0,
    finished: 0,
    position: [0, 0, 0, 0],
    name: "r",
    show:"red"
  };
  const yellow = {
    inside: 4,
    outside: 0,
    finished: 0,
    position: [0, 0, 0, 0],
    name: "y",
    show:"yellow"
  };
  const green = {
    inside: 4,
    outside: 0,
    finished: 0,
    position: [0, 0, 0, 0],
    name: "g",
    show: "green"
  };

  let player = yellow;
  let diceValue = 0;
  let canRoll = true;
  let hasRolled = false;

  // function returns a dice randon dice value
  const diceRoll = (e) => {
    if (canRoll) {
      canRoll = false;
      const diceOption = [1, 2, 3, 4, 5, 6];
      let dice = Math.floor(Math.random() * 6) + 1;
      diceValue = dice;
      display.innerText = ` ${player.show} has rolled a ${dice}, choose a token to make a move`
      if (dice != 6 && player.inside == 4) {
        display.innerText = `${player.show} rolled a ${dice} turn has been skipped`
        changePlayer();
        canRoll = true;
      }
      return dice;
    } else {
      // display for players to know whose turn it is to play
      display.innerText = `${player.show} has rolled a ${diceValue}`
    }
  };

  // returns the starting position of each player when called
  function getPosition(value) {
    switch (value) {
      case "1":
        return player.position[0];
      case "2":
        return player.position[1];
      case "3":
        return player.position[2];
      case "4":
        return player.position[3];
      default:
        console.log("error");
    }
  }
  // returns the starting position of each player when called
  function getHome(i) {
    switch (player.name) {
      case "y":
        player.position[i] = 1;
        return 1;
      case "b":
        player.position[i] = 14;
        return 14;
      case "g":
        player.position[i] = 27;
        return 27;
      case "r":
        player.position[i] = 40;
        return 40;
      default:
        console.log("error");
    }
  }

  // changes player
  function changePlayer() {
    if (player == blue) player = green;
    else if (player == green) player = red;
    else if (player == red) player = yellow;
    else player = blue;
  }

  // make a move and update position in object
  function moveToken(e, i) {
    canRoll = true;
    console.log(player.name);
    console.log(i);
    console.log(player.position[i]);
    switch (player.name) {
      case "y":
        if (player.position[i] < 52) {
          if (player.position[i] > 45 && player.position[i] < 51) {
            if (player.position[i] + diceValue > 51)
              player.position[i] = player.position[i] + diceValue + 1;
            else player.position[i] = player.position[i] + diceValue;
            e.object.position.x = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.x;
            e.object.position.z = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.z;
          } else {
            player.position[i] = player.position[i] + diceValue;
            e.object.position.x = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.x;
            e.object.position.z = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.z;
          }
        } else {
          // check if you have won else moveplayer.position[i] = player.position[i] + diceValue;
          if (player.position[i] + diceValue < 58) {
            player.position[i] = player.position[i] + diceValue;
            e.object.position.x = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.x;
            e.object.position.z = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.z;
          } else if (player.position[i] + diceValue == 58) {
            document.innerText = "don't mind if I win"
            player.position[i] = 73;
            e.object.position.x = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.x;
            e.object.position.z = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.z;
            player.outside--;
            player.finished++;
          } else {
            document.innerText = "try again you can't go in until you get the exact value"
          }
        }

        break;
      case "b":
        if (player.position[i] + diceValue > 52) {
          if (player.position[i] > 46 && player.position[i] < 53) {
            player.position[i] = player.position[i] + diceValue - 52;
            e.object.position.x = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.x;
            e.object.position.z = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.z;
          } else {
            // check if you have won else move
            if (player.position[i] + diceValue < 63) {
              player.position[i] = player.position[i] + diceValue;
              e.object.position.x = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.x;
              e.object.position.z = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.z;
            } else if (player.position[i] + diceValue == 63) {
              document.innerText = "don't mind if I win"
              player.position[i] = 73;
              e.object.position.x = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.x;
              e.object.position.z = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.z;
              player.outside--;
              player.finished++;
            } else {
              document.innerText = "try again you can't go in"
            }
          }
        } else if (player.position[i] >= 7 && player.position[i] <= 12) {
          if (player.position[i] + diceValue > 12) {
            let sum = player.position[i] + diceValue + 45;
            if (sum > 62) {
              document.innerText = "a token has finished"
              player.position[i] = 72;
              e.object.position.x = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.x;
              e.object.position.z = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.z;
              player.outside--;
              player.finshed++;
            } else {
              player.position[i] = sum;
              e.object.position.x = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.x;
              e.object.position.z = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.z;
            }
          } else {
            player.position[i] = player.position[i] + diceValue;
            e.object.position.x = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.x;
            e.object.position.z = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.z;
          }
        } else {
          player.position[i] = player.position[i] + diceValue;
          e.object.position.x = state.scene.getObjectByName(
            `Path${player.position[i]}`
          ).position.x;
          e.object.position.z = state.scene.getObjectByName(
            `Path${player.position[i]}`
          ).position.z;
        }
        break;
      case "r":
        if (player.position[i] + diceValue > 52) {
          if (player.position[i] > 46 && player.position[i] < 53) {
            player.position[i] = player.position[i] + diceValue - 52;
            e.object.position.x = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.x;
            e.object.position.z = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.z;
          } else {
            // check if you have won else move
            if (player.position[i] + diceValue < 73) {
              player.position[i] = player.position[i] + diceValue;
              e.object.position.x = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.x;
              e.object.position.z = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.z;
            } else if (player.position[i] + diceValue == 73) {
              display.innerText = "don't mind if I win"
              player.position[i] = 73;
              e.object.position.x = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.x;
              e.object.position.z = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.z;
              player.outside--;
              player.finished++;
            } else {
              display.innerText = "try again you can't go in"
            }
          }
        } else if (player.position[i] >= 33 && player.position[i] <= 38) {
          if (player.position[i] + diceValue > 38) {
            let sum = player.position[i] + diceValue + 29;
            if (sum > 72) {
              document.innerText = "a token has finished"
              player.position[i] = 73;
              e.object.position.x = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.x;
              e.object.position.z = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.z;
              player.outside--;
              player.finshed++;
            } else {
              player.position[i] = sum;
              e.object.position.x = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.x;
              e.object.position.z = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.z;
            }
          } else {
            player.position[i] = player.position[i] + diceValue;
            e.object.position.x = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.x;
            e.object.position.z = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.z;
          }
        } else {
          player.position[i] = player.position[i] + diceValue;
          e.object.position.x = state.scene.getObjectByName(
            `Path${player.position[i]}`
          ).position.x;
          e.object.position.z = state.scene.getObjectByName(
            `Path${player.position[i]}`
          ).position.z;
        }
        break;
      case "g":
        if (player.position[i] + diceValue > 52) {
          if (player.position[i] > 46 && player.position[i] < 53) {
            player.position[i] = player.position[i] + diceValue - 52;
            e.object.position.x = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.x;
            e.object.position.z = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.z;
          } else {
            // check if you have won else move
            // check if you have won else move
            if (player.position[i] + diceValue < 68) {
              player.position[i] = player.position[i] + diceValue;
              e.object.position.x = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.x;
              e.object.position.z = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.z;
            } else if (player.position[i] + diceValue == 68) {
              display.innerText = "don't mind if I win"
              player.position[i] = 73;
              e.object.position.x = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.x;
              e.object.position.z = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.z;
              player.outside--;
              player.finshed++;
            } else {
              display.innerText = "try again you can't go in"
            }
          }
        } else if (player.position[i] >= 20 && player.position[i] <= 25) {
          if (player.position[i] + diceValue > 25) {
            let sum = player.position[i] + diceValue + 37;
            if (sum > 67) {
              display.innerText = "a token has finished"
              player.position[i] = 73;
              e.object.position.x = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.x;
              e.object.position.z = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.z;
              player.outside--;
              player.finshed++;
            } else {
              player.position[i] = sum;
              e.object.position.x = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.x;
              e.object.position.z = state.scene.getObjectByName(
                `Path${player.position[i]}`
              ).position.z;
            }
          } else {
            player.position[i] = player.position[i] + diceValue;
            e.object.position.x = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.x;
            e.object.position.z = state.scene.getObjectByName(
              `Path${player.position[i]}`
            ).position.z;
          }
        } else {
          player.position[i] = player.position[i] + diceValue;
          e.object.position.x = state.scene.getObjectByName(
            `Path${player.position[i]}`
          ).position.x;
          e.object.position.z = state.scene.getObjectByName(
            `Path${player.position[i]}`
          ).position.z;
        }
        break;
      default:
        console.log("error");
    }
  }
  // control for eventListener
  const action = (e) => {
    console.log(nodes);
    // restriction for tokens eventListeners
    console.log(e.object.name);
    if (e.object.name.includes(player.name) && diceValue) {
      // console.log(state.scene)
      // console.log(e.object.name.substring(1,2))
      // for getting the position of each token
      let index = e.object.name.substring(1, 2);
      if (diceValue == 6) {
        if (getPosition(index)) {
          // if token is outside move with dice Number
          console.log(player.position[index]);
          console.log(yellow, blue, green, red);
          moveToken(e, index - 1);
          console.log(yellow, blue, green, red);
          diceValue = 0;
          changePlayer();
        } else {
          // if token is inside move to starting path
          canRoll = true;
          console.log("inside here");
          let home = getHome(index - 1);
          e.object.position.x = state.scene.getObjectByName(
            `Path${home}`
          ).position.x;
          e.object.position.z = state.scene.getObjectByName(
            `Path${home}`
          ).position.z;
          player.outside++;
          player.inside--;
          diceValue = 0;
          changePlayer();
        }
      } else {
        if (player.outside) {
          console.log("inger");
          if (getPosition(index)) {
            // if token is outside move with dice Number
            console.log(player.position[index]);
            console.log(yellow, blue, green, red);
            moveToken(e, index - 1);
            console.log(yellow, blue, green, red);
            diceValue = 0;
            changePlayer();
          }
        } else {
          display.innerText = ` die was rolled: ${player.name}'s turn skipped `
          diceValue = 0;
          changePlayer();
        }
      }

      let value = getPosition(index);
      console.log(state.scene.getObjectByName(`Path${value}`));
      // e.object.position.x =state.scene.getObjectByName(`Path${value}`).position.x
      // e.object.position.z =state.scene.getObjectByName(`Path${value}`).position.z
      // ends here
      console.log(value);
      value = value + 1;
      console.log(value);
      // this must be done at the end of all play
    } else {
      console.log("not sure");
    }
  };

  const play = () => {
    console.log(player);
    if (diceValue == 6) {
    }
    changePlayer();
  };

  return (
    <>
      <color attach="background" args={["#fef3e2"]} />
      <group {...props} dispose={null}>
        <mesh
          name="Path76"
          geometry={nodes.Path76.geometry}
          material={materials["Path76 Material"]}
          castShadow
          receiveShadow
          position={[122.49, 264.46, -229.46]}
          rotation={[0, 0, Math.PI]}
          scale={[-1.32, 0.93, 1.19]}
        />
        <mesh
          name="Path75"
          geometry={nodes.Path75.geometry}
          material={materials["Path75 Material"]}
          castShadow
          receiveShadow
          position={[-277.14, 264.46, 133.87]}
          rotation={[0, 0, -Math.PI]}
          scale={[-1.32, 0.93, 1.19]}
        />
        <mesh
          name="Path74"
          geometry={nodes.Path74.geometry}
          material={materials["Path74 Material"]}
          castShadow
          receiveShadow
          position={[121.59, 264.46, 496.33]}
          rotation={[Math.PI, 0, 0]}
          scale={[-1.32, 0.93, 1.19]}
        />
        <mesh
          name="Path73"
          geometry={nodes.Path73.geometry}
          material={materials["Path73 Material"]}
          castShadow
          receiveShadow
          position={[521.26, 264.46, 133.77]}
          rotation={[Math.PI, 0, 0]}
          scale={[-1.32, 0.93, 1.19]}
        />
        <group
          name="dice"
          position={[117.87, 423.46, 206.18]}
          rotation={[1.67, -0.07, 2.87]}
          scale={[0.97, 0.95, 0.97]}
        >
          <mesh
            name="box"
            onClick={diceRoll}
            geometry={nodes.box.geometry}
            material={materials.dice}
            castShadow
            receiveShadow
            position={[-0.7, -0.06, -0.52]}
            scale={1.89}
          />
          <group name="6" position={[-2.87, -103.32, 1.33]}>
            <mesh
              name="17"
              geometry={nodes['17'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[57.99, 0, -59.71]}
              rotation={[Math.PI, 0, 0]}
              scale={[0.62, 0.06, 0.62]}
            />
            <mesh
              name="16"
              geometry={nodes['16'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[57.99, 0, -0.66]}
              rotation={[Math.PI, 0, 0]}
              scale={[0.62, 0.06, 0.62]}
            />
            <mesh
              name="15"
              geometry={nodes['15'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[57.99, 0, 59.71]}
              rotation={[Math.PI, 0, 0]}
              scale={[0.62, 0.06, 0.62]}
            />
            <mesh
              name="14"
              geometry={nodes['14'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[-57.99, 0, -59.71]}
              rotation={[Math.PI, 0, 0]}
              scale={[0.62, 0.06, 0.62]}
            />
            <mesh
              name="13"
              geometry={nodes['13'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[-57.99, 0, -0.66]}
              rotation={[Math.PI, 0, 0]}
              scale={[0.62, 0.06, 0.62]}
            />
            <mesh
              name="12"
              geometry={nodes['12'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[-57.99, 0, 59.71]}
              rotation={[Math.PI, 0, 0]}
              scale={[0.62, 0.06, 0.62]}
            />
          </group>
          <group name="5" position={[104.25, 3.92, 0.11]}>
            <mesh
              name="11"
              geometry={nodes['11'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[0, -0.11, -2.6]}
              rotation={[Math.PI / 2, 0, -Math.PI / 2]}
              scale={[0.61, 0.01, 0.62]}
            />
            <mesh
              name="10"
              geometry={nodes['10'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[0, 58.74, -57.35]}
              rotation={[Math.PI / 2, 0, -Math.PI / 2]}
              scale={[0.61, 0.01, 0.62]}
            />
            <mesh
              name="9"
              geometry={nodes['9'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[0, -59.39, -58.97]}
              rotation={[Math.PI / 2, 0, -Math.PI / 2]}
              scale={[0.61, 0.01, 0.62]}
            />
            <mesh
              name="8"
              geometry={nodes['8'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[0, -58.3, 58.97]}
              rotation={[Math.PI / 2, 0, -Math.PI / 2]}
              scale={[0.61, 0.01, 0.62]}
            />
            <mesh
              name="7"
              geometry={nodes['7'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[0, 59.39, 58.97]}
              rotation={[Math.PI / 2, 0, -Math.PI / 2]}
              scale={[0.61, 0.01, 0.62]}
            />
          </group>
          <group name="4" position={[2.65, 103.32, 0.13]}>
            <mesh
              name="21"
              geometry={nodes['21'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[53.69, 0, 53.09]}
              scale={[0.62, 0.06, 0.62]}
            />
            <mesh
              name="20"
              geometry={nodes['20'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[-53.69, 0, 53.09]}
              scale={[0.62, 0.06, 0.62]}
            />
            <mesh
              name="19"
              geometry={nodes['19'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[53.69, 0, -53.09]}
              scale={[0.62, 0.06, 0.62]}
            />
            <mesh
              name="18"
              geometry={nodes['18'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[-53.69, 0, -53.09]}
              scale={[0.62, 0.06, 0.62]}
            />
          </group>
          <group name="3" position={[-4.18, 0.93, -103.36]}>
            <mesh
              name="51"
              geometry={nodes['51'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[-58.92, -61.36, 0]}
              rotation={[Math.PI / 2, 0, Math.PI]}
              scale={[0.62, 0.06, 0.62]}
            />
            <mesh
              name="41"
              geometry={nodes['41'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[2.99, 0, 0]}
              rotation={[Math.PI / 2, 0, Math.PI]}
              scale={[0.62, 0.06, 0.62]}
            />
            <mesh
              name="31"
              geometry={nodes['31'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[58.92, 61.36, 0]}
              rotation={[Math.PI / 2, 0, Math.PI]}
              scale={[0.62, 0.06, 0.62]}
            />
          </group>
          <group name="2" position={[-104.25, 0.07, 3.39]}>
            <mesh
              name="61"
              geometry={nodes['61'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[0, -57.34, 57.34]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              scale={[0.62, 0.06, 0.62]}
            />
            <mesh
              name="22"
              geometry={nodes['22'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[0, 57.34, -57.34]}
              rotation={[Math.PI / 2, 0, Math.PI / 2]}
              scale={[0.62, 0.06, 0.62]}
            />
          </group>
          <group name="1" position={[1.63, 0.56, 103.36]}>
            <mesh
              name="110"
              geometry={nodes['110'].geometry}
              material={materials[' points']}
              castShadow
              receiveShadow
              position={[0, 0, 0]}
              rotation={[Math.PI / 2, 0, 0]}
              scale={[0.62, 0.06, 0.62]}
            />
          </group>
        </group>
        
        <mesh
          name="g4"
          onClick={action}
          geometry={nodes.g4.geometry}
          material={materials["g4 Material"]}
          castShadow
          receiveShadow
          position={[927.31, 649.79, -1070.61]}
          scale={1.41}
        />
        <mesh
          name="g3"
          onClick={action}
          geometry={nodes.g3.geometry}
          material={materials["g3 Material"]}
          castShadow
          receiveShadow
          position={[1384.24, 649.79, -1070.61]}
          scale={1.41}
        />
        <mesh
          name="g2"
          onClick={action}
          geometry={nodes.g2.geometry}
          material={materials["g2 Material"]}
          castShadow
          receiveShadow
          position={[1384.24, 649.37, -523.86]}
          scale={1.41}
        />
        <mesh
          name="g1"
          onClick={action}
          geometry={nodes.g1.geometry}
          material={materials["g1 Material"]}
          castShadow
          receiveShadow
          position={[927.31, 649.79, -523.86]}
          scale={1.41}
        />
        <mesh
          name="b4"
          onClick={action}
          geometry={nodes.b4.geometry}
          material={materials["b4 Material"]}
          castShadow
          receiveShadow
          position={[-677.71, 649.37, -1070.61]}
          scale={[1.4, 1.41, 1.41]}
        />
        <mesh
          name="b3"
          onClick={action}
          geometry={nodes.b3.geometry}
          material={materials["b3 Material"]}
          castShadow
          receiveShadow
          position={[-1134.78, 649.37, -1070.61]}
          scale={1.41}
        />
        <mesh
          name="b2"
          onClick={action}
          geometry={nodes.b2.geometry}
          material={materials["b2 Material"]}
          castShadow
          receiveShadow
          position={[-1134.78, 649.37, -523.86]}
          scale={1.41}
        />
        <mesh
          name="b1"
          onClick={action}
          geometry={nodes.b1.geometry}
          material={materials["b1 Material"]}
          castShadow
          receiveShadow
          position={[-678.71, 649.37, -523.86]}
          scale={[1.4, 1.41, 1.41]}
        />
        <mesh
          name="r4"
          onClick={action}
          geometry={nodes.r4.geometry}
          material={materials["r4 Material"]}
          castShadow
          receiveShadow
          position={[1384.24, 649.37, 832.74]}
          scale={1.41}
        />
        <mesh
          name="r3"
          onClick={action}
          geometry={nodes.r3.geometry}
          material={materials["r3 Material"]}
          castShadow
          receiveShadow
          position={[1384.24, 649.37, 1300.51]}
          scale={1.41}
        />
        <mesh
          name="r2"
          onClick={action}
          geometry={nodes.r2.geometry}
          material={materials["r2 Material"]}
          castShadow
          receiveShadow
          position={[927.31, 649.37, 1300.51]}
          scale={1.41}
        />
        <mesh
          name="r1"
          onClick={action}
          geometry={nodes.r1.geometry}
          material={materials["r1 Material"]}
          castShadow
          receiveShadow
          position={[927.31, 649.37, 832.74]}
          scale={1.41}
        />
        <mesh
          name="y4"
          onClick={action}
          geometry={nodes.y4.geometry}
          material={materials.pawnwood}
          castShadow
          receiveShadow
          position={[-1137.25, 649.37, 828.72]}
          rotation={[0, 0, 0]}
          scale={1.41}
        />
        <mesh
          name="y3"
          onClick={action}
          geometry={nodes.y3.geometry}
          material={materials.pawnwood}
          castShadow
          receiveShadow
          position={[-676.64, 649.79, 828.72]}
          scale={1.41}
        />
        <mesh
          name="y2"
          onClick={action}
          geometry={nodes.y2.geometry}
          material={materials.pawnwood}
          castShadow
          receiveShadow
          position={[-676.64, 649.37, 1296.49]}
          rotation={[0, 0, 0]}
          scale={1.41}
        />
        <mesh
          name="y1"
          onClick={action}
          geometry={nodes.y1.geometry}
          material={materials.pawnwood}
          castShadow
          receiveShadow
          position={[-1137.25, 649.79, 1296.49]}
          scale={1.41}
        />
        <mesh
          name="Path59"
          geometry={nodes.Path59.geometry}
          material={materials["Path59 Material"]}
          castShadow
          receiveShadow
          position={[-1011.04, 272.25, 132.82]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path61"
          geometry={nodes.Path61.geometry}
          material={materials["Path61 Material"]}
          castShadow
          receiveShadow
          position={[-592.76, 272.25, 134.4]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path62"
          geometry={nodes.Path62.geometry}
          material={materials["Path62 Material"]}
          castShadow
          receiveShadow
          position={[-378.57, 272.25, 134.93]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path12"
          geometry={nodes.Path12.geometry}
          material={materials["Path12 Material"]}
          castShadow
          receiveShadow
          position={[-1432.3, 272.25, 132.29]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path58"
          geometry={nodes.Path58.geometry}
          material={materials["Path58 Material"]}
          castShadow
          receiveShadow
          position={[-1224.55, 272.25, 132.82]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path60"
          geometry={nodes.Path60.geometry}
          material={materials["Path60 Material"]}
          castShadow
          receiveShadow
          position={[-799.57, 272.25, 133.87]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path17"
          geometry={nodes.Path17.geometry}
          material={materials["Path17 Material"]}
          castShadow
          receiveShadow
          position={[-592.02, 272.25, -103.22]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path18"
          geometry={nodes.Path18.geometry}
          material={materials["Path18 Material"]}
          castShadow
          receiveShadow
          position={[-377.82, 272.25, -102.69]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path13"
          geometry={nodes.Path13.geometry}
          material={materials["Path13 Material"]}
          castShadow
          receiveShadow
          position={[-1431.55, 272.25, -105.33]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path14"
          geometry={nodes.Path14.geometry}
          material={materials["Path14 Material"]}
          castShadow
          receiveShadow
          position={[-1221.43, 272.25, -104.8]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path15"
          geometry={nodes.Path15.geometry}
          material={materials["Path15 Material"]}
          castShadow
          receiveShadow
          position={[-1008.94, 272.25, -104.27]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path16"
          geometry={nodes.Path16.geometry}
          material={materials["Path16 Material"]}
          castShadow
          receiveShadow
          position={[-798.82, 272.25, -103.75]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path7"
          geometry={nodes.Path7.geometry}
          material={materials["Path7 Material"]}
          castShadow
          receiveShadow
          position={[-589.63, 272.25, 372.19]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.25]}
        />
        <mesh
          name="Path6"
          geometry={nodes.Path6.geometry}
          material={materials["Path6 Material"]}
          castShadow
          receiveShadow
          position={[-377.1, 272.25, 372.72]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.25]}
        />
        <mesh
          name="Path11"
          geometry={nodes.Path11.geometry}
          material={materials["Path11 Material"]}
          castShadow
          receiveShadow
          position={[-1433.02, 272.25, 370.08]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.25]}
        />
        <mesh
          name="Path10"
          geometry={nodes.Path10.geometry}
          material={materials["Path10 Material"]}
          castShadow
          receiveShadow
          position={[-1224.32, 272.25, 370.61]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.25]}
        />
        <mesh
          name="Path9"
          geometry={nodes.Path9.geometry}
          material={materials["Path9 Material"]}
          castShadow
          receiveShadow
          position={[-1013.28, 272.25, 371.14]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.25]}
        />
        <mesh
          name="Path8"
          geometry={nodes.Path8.geometry}
          material={materials["Path8 Material"]}
          castShadow
          receiveShadow
          position={[-804.58, 272.25, 371.67]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.25]}
        />
        <mesh
          name="Path68"
          geometry={nodes.Path68.geometry}
          material={materials["Path68 Material"]}
          castShadow
          receiveShadow
          position={[1471.86, 272.25, 134.4]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path38"
          geometry={nodes.Path38.geometry}
          material={materials["Path38 Material"]}
          castShadow
          receiveShadow
          position={[1681.76, 272.25, 134.93]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path72"
          geometry={nodes.Path72.geometry}
          material={materials["Path72 Material"]}
          castShadow
          receiveShadow
          position={[629.16, 272.25, 132.29]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path71"
          geometry={nodes.Path71.geometry}
          material={materials["Path71 Material"]}
          castShadow
          receiveShadow
          position={[839.06, 272.25, 132.82]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path70"
          geometry={nodes.Path70.geometry}
          material={materials["Path70 Material"]}
          castShadow
          receiveShadow
          position={[1051.31, 272.25, 133.35]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path69"
          geometry={nodes.Path69.geometry}
          material={materials["Path69 Material"]}
          castShadow
          receiveShadow
          position={[1261.21, 272.25, 133.87]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path36"
          geometry={nodes.Path36.geometry}
          material={materials["Path36 Material"]}
          castShadow
          receiveShadow
          position={[1473.23, 272.25, -103.48]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path37"
          geometry={nodes.Path37.geometry}
          material={materials["Path37 Material"]}
          castShadow
          receiveShadow
          position={[1683.13, 272.25, -102.95]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path32"
          geometry={nodes.Path32.geometry}
          material={materials["Path32 Material"]}
          castShadow
          receiveShadow
          position={[630.53, 272.25, -105.59]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path33"
          geometry={nodes.Path33.geometry}
          material={materials["Path33 Material"]}
          castShadow
          receiveShadow
          position={[838.55, 272.25, -105.06]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path34"
          geometry={nodes.Path34.geometry}
          material={materials["Path34 Material"]}
          castShadow
          receiveShadow
          position={[1052.68, 272.25, -104.53]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path35"
          geometry={nodes.Path35.geometry}
          material={materials["Path35 Material"]}
          castShadow
          receiveShadow
          position={[1262.58, 272.25, -104.01]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path40"
          geometry={nodes.Path40.geometry}
          material={materials["Path40 Material"]}
          castShadow
          receiveShadow
          position={[1471.12, 272.25, 372.19]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path39"
          geometry={nodes.Path39.geometry}
          material={materials["Path39 Material"]}
          castShadow
          receiveShadow
          position={[1681.02, 272.25, 372.72]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path44"
          geometry={nodes.Path44.geometry}
          material={materials["Path44 Material"]}
          castShadow
          receiveShadow
          position={[628.42, 272.25, 370.08]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path43"
          geometry={nodes.Path43.geometry}
          material={materials["Path43 Material"]}
          castShadow
          receiveShadow
          position={[838.32, 272.25, 370.61]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path42"
          geometry={nodes.Path42.geometry}
          material={materials["Path42 Material"]}
          castShadow
          receiveShadow
          position={[1050.58, 272.25, 371.14]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path41"
          geometry={nodes.Path41.geometry}
          material={materials["Path41 Material"]}
          castShadow
          receiveShadow
          position={[1260.48, 272.25, 371.67]}
          rotation={[0, Math.PI / 2, 0]}
          scale={[1.69, 0.93, 1.26]}
        />
        <mesh
          name="Path66"
          geometry={nodes.Path66.geometry}
          material={materials["Path66 Material"]}
          castShadow
          receiveShadow
          position={[123.72, 272.25, -511.44]}
          scale={[1.88, 0.93, 1.13]}
        />
        <mesh
          name="Path67"
          geometry={nodes.Path67.geometry}
          material={materials["Path67 Material"]}
          castShadow
          receiveShadow
          position={[123.72, 272.25, -322.86]}
          scale={[1.88, 0.93, 1.13]}
        />
        <mesh
          name="Path25"
          geometry={nodes.Path25.geometry}
          material={materials["Path25 Material"]}
          castShadow
          receiveShadow
          position={[123.72, 272.25, -1268.54]}
          scale={[1.88, 0.93, 1.13]}
        />
        <mesh
          name="Path63"
          geometry={nodes.Path63.geometry}
          material={materials["Path63 Material"]}
          castShadow
          receiveShadow
          position={[123.72, 272.25, -1079.96]}
          scale={[1.88, 0.93, 1.13]}
        />
        <mesh
          name="Path64"
          geometry={nodes.Path64.geometry}
          material={materials["Path64 Material"]}
          castShadow
          receiveShadow
          position={[123.72, 272.25, -889.27]}
          scale={[1.88, 0.93, 1.13]}
        />
        <mesh
          name="Path65"
          geometry={nodes.Path65.geometry}
          material={materials["Path65 Material"]}
          castShadow
          receiveShadow
          position={[123.72, 272.25, -700.69]}
          scale={[1.88, 0.93, 1.13]}
        />
        <mesh
          name="Path30"
          geometry={nodes.Path30.geometry}
          material={materials["Path30 Material"]}
          castShadow
          receiveShadow
          position={[390.51, 272.25, -511.44]}
          scale={[1.88, 0.93, 1.13]}
        />
        <mesh
          name="Path31"
          geometry={nodes.Path31.geometry}
          material={materials["Path31 Material"]}
          castShadow
          receiveShadow
          position={[390.51, 272.25, -322.86]}
          scale={[1.88, 0.93, 1.13]}
        />
        <mesh
          name="Path26"
          geometry={nodes.Path26.geometry}
          material={materials["Path26 Material"]}
          castShadow
          receiveShadow
          position={[390.51, 272.25, -1268.54]}
          scale={[1.88, 0.93, 1.13]}
        />
        <mesh
          name="Path27"
          geometry={nodes.Path27.geometry}
          material={materials["Path27 Material"]}
          castShadow
          receiveShadow
          position={[390.51, 272.25, -1079.96]}
          scale={[1.88, 0.93, 1.13]}
        />
        <mesh
          name="Path28"
          geometry={nodes.Path28.geometry}
          material={materials["Path28 Material"]}
          castShadow
          receiveShadow
          position={[390.51, 272.25, -889.27]}
          scale={[1.88, 0.93, 1.13]}
        />
        <mesh
          name="Path29"
          geometry={nodes.Path29.geometry}
          material={materials["Path29 Material"]}
          castShadow
          receiveShadow
          position={[390.51, 272.25, -700.69]}
          scale={[1.88, 0.93, 1.13]}
        />
        <mesh
          name="Path20"
          geometry={nodes.Path20.geometry}
          material={materials["Path20 Material"]}
          castShadow
          receiveShadow
          position={[-143.08, 272.25, -511.44]}
          scale={[1.88, 0.93, 1.13]}
        />
        <mesh
          name="Path19"
          geometry={nodes.Path19.geometry}
          material={materials["Path19 Material"]}
          castShadow
          receiveShadow
          position={[-143.08, 272.25, -322.86]}
          scale={[1.88, 0.93, 1.13]}
        />
        <mesh
          name="Path24"
          geometry={nodes.Path24.geometry}
          material={materials["Path24 Material"]}
          castShadow
          receiveShadow
          position={[-143.08, 272.25, -1268.54]}
          scale={[1.88, 0.93, 1.13]}
        />
        <mesh
          name="Path23"
          geometry={nodes.Path23.geometry}
          material={materials["Path23 Material"]}
          castShadow
          receiveShadow
          position={[-143.08, 272.25, -1079.96]}
          scale={[1.88, 0.93, 1.13]}
        />
        <mesh
          name="Path22"
          geometry={nodes.Path22.geometry}
          material={materials["Path22 Material"]}
          castShadow
          receiveShadow
          position={[-143.08, 272.25, -889.27]}
          scale={[1.88, 0.93, 1.13]}
        />
        <mesh
          name="Path21"
          geometry={nodes.Path21.geometry}
          material={materials["Path21 Material"]}
          castShadow
          receiveShadow
          position={[-143.08, 272.25, -700.69]}
          scale={[1.88, 0.93, 1.13]}
        />
        <mesh
          name="Path53"
          geometry={nodes.Path53.geometry}
          material={materials["Path53 Material"]}
          castShadow
          receiveShadow
          position={[123.72, 272.25, 1351.67]}
          scale={[1.87, 0.93, 1.13]}
        />
        <mesh
          name="Path51"
          geometry={nodes.Path51.geometry}
          material={materials["Path51 Material"]}
          castShadow
          receiveShadow
          position={[123.72, 272.25, 1540.25]}
          scale={[1.87, 0.93, 1.13]}
        />
        <mesh
          name="Path57"
          geometry={nodes.Path57.geometry}
          material={materials["Path57 Material"]}
          castShadow
          receiveShadow
          position={[123.72, 272.25, 594.57]}
          scale={[1.87, 0.93, 1.13]}
        />
        <mesh
          name="Path56"
          geometry={nodes.Path56.geometry}
          material={materials["Path56 Material"]}
          castShadow
          receiveShadow
          position={[123.72, 272.25, 783.15]}
          scale={[1.87, 0.93, 1.13]}
        />
        <mesh
          name="Path55"
          geometry={nodes.Path55.geometry}
          material={materials["Path55 Material"]}
          castShadow
          receiveShadow
          position={[123.72, 272.25, 973.84]}
          scale={[1.87, 0.93, 1.13]}
        />
        <mesh
          name="Path54"
          geometry={nodes.Path54.geometry}
          material={materials["Path54 Material"]}
          castShadow
          receiveShadow
          position={[123.72, 272.25, 1162.42]}
          scale={[1.87, 0.93, 1.13]}
        />
        <mesh
          name="Path49"
          geometry={nodes.Path49.geometry}
          material={materials["Path49 Material"]}
          castShadow
          receiveShadow
          position={[385.61, 272.25, 1351.67]}
          scale={[1.87, 0.93, 1.13]}
        />
        <mesh
          name="Path50"
          geometry={nodes.Path50.geometry}
          material={materials["Path50 Material"]}
          castShadow
          receiveShadow
          position={[385.61, 272.25, 1540.25]}
          scale={[1.87, 0.93, 1.13]}
        />
        <mesh
          name="Path45"
          geometry={nodes.Path45.geometry}
          material={materials["Path45 Material"]}
          castShadow
          receiveShadow
          position={[385.61, 272.25, 594.57]}
          scale={[1.87, 0.93, 1.13]}
        />
        <mesh
          name="Path46"
          geometry={nodes.Path46.geometry}
          material={materials["Path46 Material"]}
          castShadow
          receiveShadow
          position={[385.61, 272.25, 783.15]}
          scale={[1.87, 0.93, 1.13]}
        />
        <mesh
          name="Path47"
          geometry={nodes.Path47.geometry}
          material={materials["Path47 Material"]}
          castShadow
          receiveShadow
          position={[385.61, 272.25, 973.84]}
          scale={[1.87, 0.93, 1.13]}
        />
        <mesh
          name="Path48"
          geometry={nodes.Path48.geometry}
          material={materials["Path48 Material"]}
          castShadow
          receiveShadow
          position={[385.61, 272.25, 1162.42]}
          rotation={[0, 0, 0]}
          scale={[1.87, 0.93, 1.13]}
        />
        <mesh
          name="Path1"
          geometry={nodes.Path1.geometry}
          material={materials["Path1 Material"]}
          castShadow
          receiveShadow
          position={[-138.73, 272.25, 1351.67]}
          rotation={[0, 0, 0]}
          scale={[1.87, 0.93, 1.13]}
        />
        <mesh
          name="Path52"
          geometry={nodes.Path52.geometry}
          material={materials["Path52 Material"]}
          castShadow
          receiveShadow
          position={[-138.73, 272.25, 1540.25]}
          scale={[1.87, 0.93, 1.13]}
        />
        <mesh
          name="Path5"
          geometry={nodes.Path5.geometry}
          material={materials["Path5 Material"]}
          castShadow
          receiveShadow
          position={[-138.73, 272.25, 594.57]}
          scale={[1.87, 0.93, 1.13]}
        />
        <mesh
          name="Path4"
          geometry={nodes.Path4.geometry}
          material={materials["Path4 Material"]}
          castShadow
          receiveShadow
          position={[-138.73, 272.25, 783.15]}
          scale={[1.87, 0.93, 1.13]}
        />
        <mesh
          name="Path3"
          geometry={nodes.Path3.geometry}
          material={materials["Path3 Material"]}
          castShadow
          receiveShadow
          position={[-138.73, 272.25, 973.84]}
          scale={[1.87, 0.93, 1.13]}
        />
        <mesh
          name="Path2"
          geometry={nodes.Path2.geometry}
          material={materials["Path2 Material"]}
          castShadow
          receiveShadow
          position={[-138.73, 272.25, 1162.42]}
          scale={[1.87, 0.93, 1.13]}
        />
        <directionalLight
          name="Directonal Light"
          castShadow
          intensity={0.75}
          shadow-mapSize-width={1024}
          shadow-mapSize-height={1024}
          shadow-camera-near={-10000}
          shadow-camera-far={100000}
          shadow-camera-left={-1150}
          shadow-camera-right={1150}
          shadow-camera-top={1150}
          shadow-camera-bottom={-1150}
          position={[20.54, 435.84, 1.02]}
          rotation={[0, -0.04, 0]}
          scale={[1.32, 1.12, 1.19]}
        />
        <mesh
          name="Cube"
          geometry={nodes.Cube.geometry}
          material={materials["Cube Material"]}
          castShadow
          receiveShadow
          position={[-906.95, 272.25, 1062.6]}
          scale={[1.32, 1.12, 1.19]}
        />
        <mesh
          name="Cube 4"
          geometry={nodes["Cube 4"].geometry}
          material={materials["Cube 4 Material"]}
          castShadow
          receiveShadow
          position={[1155.74, 270.02, 1066.63]}
          scale={[1.32, 1.12, 1.19]}
        />
        <mesh
          name="Cube 5"
          geometry={nodes["Cube 5"].geometry}
          material={materials["Cube 5 Material"]}
          castShadow
          receiveShadow
          position={[-906.95, 272.25, -795.8]}
          scale={[1.32, 1.12, 1.19]}
        />
        <mesh
          name="Cube 51"
          geometry={nodes["Cube 51"].geometry}
          material={materials["Cube 51 Material"]}
          castShadow
          receiveShadow
          position={[1155.78, 272.25, -797.23]}
          scale={[1.32, 1.12, 1.19]}
        />
        <PerspectiveCamera
          name="23"
          makeDefault={true}
          far={100000}
          near={5}
          fov={45}
          position={[358.63, 1815.34, 4275.76]}
          rotation={[-0.4, 0.08, 0.03]}
          scale={1}
        />
      </group>
    </>
  );
}
